import type { CanvasState } from '../hooks/useCanvasTransform';

export function getViewportWorld(state: CanvasState, canvas: HTMLCanvasElement) {
  const viewLeft = (-state.offset.x) / state.scale;
  const viewTop = (-state.offset.y) / state.scale;
  const viewRight = (canvas.width - state.offset.x) / state.scale;
  const viewBottom = (canvas.height - state.offset.y) / state.scale;
  return { viewLeft, viewTop, viewRight, viewBottom };
}

export function intersectsRect(
  x: number,
  y: number,
  w: number,
  h: number,
  viewLeft: number,
  viewTop: number,
  viewRight: number,
  viewBottom: number
) {
  const xr = x + w;
  const yb = y + h;
  return !(x > viewRight || xr < viewLeft || y > viewBottom || yb < viewTop);
}


